import {theme, ThemeConfig} from "antd";

export const useThemeLayoutConfig = (): ThemeConfig => {
    const themeToken = theme.useToken();

    const customThemeConfig: ThemeConfig = {
        token: {
            colorPrimary: "#0c1d31",
            borderRadius: 10,
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        },
        components: {
            Menu: {
                itemBorderRadius: 10,
                itemMarginInline: 10,
                itemMarginBlock: 4,
                itemHeight: 44,
                iconSize: 16,
                itemSelectedBg: '#eaf2fb',
                itemActiveBg: '#f3f6fa',
                itemHoverBg: '#f3f6fa',
                itemSelectedColor: '#0c1d31',
                itemColor: '#3d4f63',
                itemHoverColor: '#0c1d31',
                activeBarBorderWidth: 0,
            },
            Layout: {
                headerBg: '#0c1d31',
                siderBg: '#ffffff',
                bodyBg: '#f3f6fa',
            },
        },
    };

    return {
        ...themeToken,
        ...customThemeConfig,
        token: {
            ...themeToken.token,
            ...customThemeConfig.token,
        },
        components: {
            ...customThemeConfig.components,
        },
    };
};
